import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=0bcaea7c&scoped=true&"
var script = {}
import style0 from "./AppHeader.vue?vue&type=style&index=0&id=0bcaea7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcaea7c",
  null
  
)

export default component.exports